import colors from "shared/styles/colors";
import { ThemeType } from "shared/styles/theme";

export const GraphFontStyles = (theme: ThemeType) => ({
	fontFamily: "'Gilroy-Medium', 'medium-fallback'",
	fontSize: "14px",
	color: colors.grey_1,
	fill: theme === ThemeType.light ? colors.black : colors.white
})

export const TooltipContentStyles = {
	color: colors.grey_1,
	borderRadius: "15px",
	backgroundColor: colors.grey_5,
	border: `1px solid ${colors.grey_2}`
}

export const TooltipLabelStyles = {
	...GraphFontStyles
}

export const getGraphFontStyles = (mode: string) => {
	return {
		fontFamily: "'Gilroy-Medium', 'medium-fallback'",
		fontSize: "12px",
		color: mode === ThemeType.light ? colors.black : colors.black,
		fill: mode === ThemeType.light ? colors.black : colors.white,
	}
}

export const getTooltipContentStyles = (mode: string) => {
	return {
		borderRadius: "15px",
		backgroundColor: mode === ThemeType.light ? colors.grey_5 : colors.grey_5,
		border: `1px solid ${mode === ThemeType.light ? colors.grey_2 : colors.grey_2}`
	}
}

export const getTooltipLabelStyles = (mode: string) => {
	return {
		...getGraphFontStyles(mode)
	}
}

export const getChartLineColor = (mode: string) => {
	return mode === ThemeType.light ? colors.purplePrimary : colors.purpleSecondary
}
